import { render, staticRenderFns } from "./CFormOOI.vue?vue&type=template&id=49be2776&"
import script from "./CFormOOI.vue?vue&type=script&lang=js&"
export * from "./CFormOOI.vue?vue&type=script&lang=js&"
import style0 from "./CFormOOI.vue?vue&type=style&index=0&id=49be2776&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports